import scrollMonitor from 'scrollmonitor'
import { requestTimeout } from '../util'
// import 'animation.gsap'
import { TweenMax, TimelineMax, gsap } from 'gsap' // Also works with TweenLite and TimelineLite
import * as ScrollMagic from 'scrollmagic'
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap'

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax, gsap)

const setupParallax = () => {
  const controller = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: 'onCenter',
      duration: '150%',
    },
  })

  $('.parallax-window').each((index, el) => {
    new ScrollMagic.Scene({ triggerElement: el }).setTween($(el).find('.panel-image'), { y: '30%' }).addTo(controller)
  })

  controller.enabled(false)

  const toggleParallax = () => {
    if (window.innerWidth < 1024) {
      controller.enabled(false)
      $('.panel-image').css('transform', '')
    } else {
      controller.enabled(true)
    }

    controller.update(true)
  }

  $(window).on('resize', toggleParallax)

  toggleParallax()
}

export default {
  can: () => $('.parallax-window').length,
  run: () => {
    setupParallax()
  },
}
